import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";

import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import { PromiseResult } from "../models/PromiseResult";
import { RestApi } from "../shared/apiUrls";
import { catchError } from "rxjs/operators";
import { CreateLicenseBody } from "../models/provider";


@Injectable({
  providedIn: 'root'
})
export class ProviderService {

  constructor(private readonly http: HttpClient) { }

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
  UpdateProviderLogo(form: FormData): Observable<PromiseResult> {
    return this.http
      .post<PromiseResult>(RestApi.Urls.ProviderMetadataApi + "Logo/Add", form)
      .pipe(catchError(this.handleError));
  }

  CreateLicense(createLicenseBody: CreateLicenseBody): Observable<PromiseResult> {
    return this.http
      .post<PromiseResult>(RestApi.Urls.ProviderApi + "license/purchase", createLicenseBody)
      .pipe(catchError(this.handleError));
  }

  Checklist(): Observable<PromiseResult> {
    return this.http
      .get<PromiseResult>(RestApi.Urls.ProviderApi + "checklist")
      .pipe(catchError(this.handleError));
  }

  getProviderAgreement(): Observable<PromiseResult> {
    return this.http
      .get<PromiseResult>(
        RestApi.Urls.ProviderApi + 'agreement'
      )
      .pipe(catchError(this.handleError));
  }

}
